import { render, staticRenderFns } from "./sbInsertStep.vue?vue&type=template&id=1c9173c5&scoped=true"
import script from "./sbInsertStep.vue?vue&type=script&lang=ts"
export * from "./sbInsertStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9173c5",
  null
  
)

export default component.exports